import { z } from 'zod';
import { LanguageSchema } from './common.js';

/** Nombre de usuario (bodega, caja_bola…) o correo. */
export const LoginBodySchema = z.object({
  user: z.string().trim().toLowerCase().min(1).max(120),
  password: z.string().min(1).max(200),
});
export type LoginBody = z.infer<typeof LoginBodySchema>;

export const LocationSummarySchema = z.object({
  id: z.number().int(),
  code: z.string(),
  name: z.string(),
  type: z.enum(['WAREHOUSE', 'STORE']),
  can_distribute: z.boolean(),
});
export type LocationSummary = z.infer<typeof LocationSummarySchema>;

/** GET /api/me: usuario autenticado, rol, permisos, ubicaciones e idioma. */
export const MeSchema = z.object({
  id: z.number().int(),
  username: z.string(),
  email: z.string().nullable(),
  full_name: z.string(),
  preferred_language: LanguageSchema,
  /** Clave temporal asignada por Gerencia: hay que cambiarla antes de seguir. */
  must_change_password: z.boolean(),
  role: z.object({ code: z.string(), name: z.string(), scoped: z.boolean() }),
  permissions: z.array(z.string()),
  /** Módulos habilitados por excepción: no vienen en el menú del rol y hay que añadirlos. */
  granted: z.array(z.string()),
  locations: z.array(LocationSummarySchema),
});
export type Me = z.infer<typeof MeSchema>;

export const PreferencesBodySchema = z.object({ preferred_language: LanguageSchema });

export const PasswordPolicy = z.string().min(8, 'PASSWORD_TOO_SHORT').max(200);
export const ChangePasswordBodySchema = z.object({
  current_password: z.string().min(1).max(200),
  new_password: PasswordPolicy,
});
